export default {"src":"/_next/static/media/prisma.d089adac.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};